import styled from 'styled-components';
import { Card, Divider } from '@amzn/storm-ui';

export const RegistrationFormWrapper = styled.form`
  width: 100%;
`;

export const RegistrationFormCard = styled(Card)`
  && {
    margin-block-end: ${({ theme }) => theme.spacing.medium.default};
  }
`;

export const RegistrationCardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `0 0 ${theme.spacing.medium.default} 0`};
  gap: ${({ theme }) => theme.spacing.small.default};
  :last-child {
    padding: ${({ theme }) => `${theme.spacing.medium.default} 0 0 0`};
  }
`;

export const RegistrationCustomDivider = styled(Divider)`
  && {
    margin: ${({ theme }) => theme.spacing.xsmall.default} 0;
  }
`;
